import ButtonSettings from 'client/components/core/Sidebar/components/Settings/entities/button-settings'
import FieldSettings from 'client/components/core/Sidebar/components/Settings/entities/field-settings'
import ContactUsButtonSettings from 'client/pages/contact-us/settings/ButtonSettings'
import ContactUsSettings from 'client/pages/contact-us/settings/ContactUsSettings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import { ContactUsButtonInterface } from 'common/types/entities/contact-us-button-interface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { FieldInterface } from 'common/types/entities/field-interface'
import React from 'react'
import { FormSettings } from 'src/editor/shared/entities/form/form-settings'
import { AttachmentsInterface } from 'src/shared/types/entities/attachments-interface'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import createCommonEntitySettings from '../createCommonEntitySettings'
import AttachmentsSettings from './settings/AttachmentsSettings'
import ContactUsFieldSettings from './settings/ContactUsFieldSettings'

function createSettingsForContactUs(entity: EntityInterface) {
  switch (entity.type) {
    case EntityTypeEnum.ContactUs:
      return <ContactUsSettings entity={entity as ContactUsInterface} />
    case EntityTypeEnum.Button:
      return <ButtonSettings entity={entity as ButtonInterface} />
    case EntityTypeEnum.ContactUsButton:
      return (
        <ContactUsButtonSettings entity={entity as ContactUsButtonInterface} />
      )
    case EntityTypeEnum.ContactUsField:
      return <ContactUsFieldSettings entity={entity as FieldInterface} />
    case EntityTypeEnum.Form:
      return <FormSettings entity={entity as FormInterface} />
    case EntityTypeEnum.Field:
      return <FieldSettings entity={entity as FieldInterface} />
    case EntityTypeEnum.Attachments:
      return <AttachmentsSettings entity={entity as AttachmentsInterface} />
    default:
      return createCommonEntitySettings(entity)
  }
}

export default createSettingsForContactUs
